import {curry} from 'ramda';
import {BASE_URL, CYPH_APP_BASE_URL, API_DELAY, MAX_RETRIES} from './constants';
import './constants'

const API_URL = BASE_URL[MODE];
let ERROR_COUNT = 0;

let responseToJson = (r) => (r.json());
let fetchApi = function(clientId, endpoint, method, body) {
    return fetch(`${API_URL}${endpoint}`, {
        method,
        mode : 'cors',
        headers :
        {
            'x-client-id' : clientId,
            'Content-Type' : 'application/json'
        },
        body:JSON.stringify(body)
    }).then(responseToJson)
};

let getStatus = curry(function (clientId, sessionId, callback) {
    fetchApi(clientId, '/checkStatus', 'POST', {sessionId})
        .then(function (data) {
            ERROR_COUNT=0;
            if (data.status==="PENDING") {
                setTimeout(getStatus.bind(null, clientId, sessionId, callback), API_DELAY);
            } else {
                callback(data);
            }
        })
        .catch(function () {
            ERROR_COUNT+=1;
            if (ERROR_COUNT<MAX_RETRIES) {
                setTimeout(getStatus.bind(null, clientId, sessionId, callback), API_DELAY);
            } else {
                callback({status:"FAILURE"});
            }
        });
});

let getUrl = curry(function (sessionId) {
    return `${CYPH_APP_BASE_URL}${sessionId}`;
});

export let CyphClient = function (clientId) {
  return {
      getStatus : getStatus(clientId),
      getUrl : getUrl()
  }
};